<template>
  <v-dialog v-model="dialog" width="400px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title>NẠP TRỰC TIẾP</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <AutocompleteStudent v-model="selectedStudent" :rules="[$rules.required]" />
          <v-text-field
            v-model="amount"
            label="Số xu"
            placeholder="Nhập số xu muốn nạp"
            outlined
            required
            dense
            class="required"
            :rules="[$rules.required]"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="cancel" width="100px" @click="cancel" outlined>Huỷ</v-btn>
        <v-btn color="primary" width="100px" class="elevation-0" @click="confirm">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import { StudentCreditApi } from '@/plugins/api'
import { mapActions, mapState } from 'vuex'
export default {
  components: { AutocompleteStudent },
  data() {
    return {
      dialog: false,
      selectedStudent: {},
      amount: '0',
    }
  },
  computed: {
    ...mapState({
      query: state => state.studentCreditUsage.query,
    }),
  },
  methods: {
    ...mapActions({ fetchItems: 'studentCreditUsage/fetch', countItems: 'studentCreditUsage/countItems' }),
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.selectedStudent = {}
    },

    async confirm() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true
        const data = {
          amount: Number(this.amount.replace(/,/g, '')),
          studentId: this.selectedStudent.id,
        }
        await StudentCreditApi.requestCharge(data)
        this.$alert.success('Nạp xu thành công')
        this.cancel()
        this.countItems({ ...this.query, type: 'in' })
        this.fetchItems({ ...this.query, type: 'in', _start: 0, _limit: 5 })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    formatNumberWithCommas(str) {
      const text = str.replace(/,/g, '')
      return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },

  watch: {
    amount: {
      handler(val) {
        if (val) {
          this.amount = this.formatNumberWithCommas(val)
        }
      },
    },
  },
}
</script>
